import { render, staticRenderFns } from "./StarshipsDeploymentDetails.vue?vue&type=template&id=54de4a62&lang=pug&"
import script from "./StarshipsDeploymentDetails.vue?vue&type=script&lang=ts&"
export * from "./StarshipsDeploymentDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports